/* globals getBasedOnEnvironment:true */
import type { Organization } from '@hotjar/navigation/src/types';
import { AUTH } from '@hotjar/webapp/constants/routes';

export const DEMO_SITE_ID = getBasedOnEnvironment({
  prod: 2327305,
  staging: 1,
  dev: 1,
});

export const DEMO_SITE_ORG_ID = getBasedOnEnvironment({
  prod: 1754014,
  staging: 1,
  dev: 1,
});

export const DEMO_SITE_NAME = getBasedOnEnvironment({
  prod: 'Hotjar Demo Site',
  staging: 'Default site 🌐',
  dev: 'Default site 🌐',
});

export const DEMO_SITE_ORG_NAME = getBasedOnEnvironment({
  prod: 'Hotjar Product Demo',
  staging: 'Test Organization',
  dev: 'Test Organization',
});

export const DEMO_SITE_ORG = {
  access: 'read',
  id: DEMO_SITE_ORG_ID,
  name: DEMO_SITE_ORG_NAME,
  sites: [{ id: DEMO_SITE_ID, name: DEMO_SITE_NAME }],
} as unknown as Organization;

export function isDemoSiteId(siteId: string | number): boolean {
  return DEMO_SITE_ID === Number(siteId);
}

export function isDemoSiteURL(pathname: string, search: string): boolean {
  // First we check if the location matches any of the tools page urls.
  // If it is, and the site ID matches the demo site IDs -> it is demo site url
  if (pathname.startsWith(`/sites/${DEMO_SITE_ID}/`)) {
    return true;
  }

  // The story is a bit different for shared recordings. We need to check if
  // the site is shared recording (/r) and then look for the demo site id
  // in the search params.
  const params = new URLSearchParams(search);
  if (pathname === '/r' && params.get('site') === String(DEMO_SITE_ID)) {
    return true;
  }

  return false;
}

export function redirectToDemoLogin(): void {
  const loginScreenUrl = new URL(AUTH.LOGIN.path, window.location.href);
  loginScreenUrl.searchParams.set('next', encodeURIComponent(window.location.href));
  loginScreenUrl.searchParams.set('demo', 'true');
  window.location.replace(loginScreenUrl.toString());
}
